import { createElement as rc, useMemo } from 'react';
import { css } from 'styled-components';
import { styled, fromTheme, webOnlyStyles, nativeOnlyStyles } from 'lib_ui-primitives';
import AbstractMenuButton from '../_abstractComponent/MenuButton';
import useActiveRecord from '../../hooks/useActiveRecord';
import useGetDbViewName from '../../hooks/useDbView/useGetDbViewName';
import useMultiSelect from '../../hooks/useMultiSelect';
import PropTypes from 'prop-types';

let ActionMenuButton = styled(AbstractMenuButton)``;

ActionMenuButton = webOnlyStyles(ActionMenuButton)`
    ${({ hNode }) =>
        hNode?.withSelection && hNode?.buttonStyle === 'tertiary'
            ? css`
                border-radius: 0 !important;
                border-width: 0 !important;
                background-color: transparent !important;
                border-left-width: 1px !important;
                border-left-color: ${fromTheme('menu', 'button', 'withSelection', 'borderColor')} !important;
                padding-left: ${fromTheme('menu', 'button', 'withSelection', 'paddingLeft')} !important;
                margin-left: ${fromTheme('menu', 'button', 'withSelection', 'marginLeft')} !important;
                color: ${fromTheme('menu', 'button', 'withSelection', 'color')} !important;
              `
            : ''}
`;

ActionMenuButton = nativeOnlyStyles(ActionMenuButton)`
    ${({ hNode }) =>
        hNode?.withSelection && hNode?.buttonStyle === 'tertiary'
            ? css`
                border-radius: 0;
                border-width: 0;
                background-color: transparent;
                border-left-width: 1px;
                border-left-color: ${fromTheme('menu', 'button', 'withSelection', 'borderColor')};
                padding-left: ${fromTheme('menu', 'button', 'withSelection', 'paddingLeft')};
                margin-left: ${fromTheme('menu', 'button', 'withSelection', 'marginLeft')};
                color: ${fromTheme('menu', 'button', 'withSelection', 'color')};
              `
            : ''}
`;
ActionMenuButton.displayName = 'ActionMenuButton';

export default function MenuButton(props) {
    const {
        hNode,
        children,
        currentRoute,
        ...otherProps
    } = props;

    const { withSelection, namespace, relation } = hNode;

    const { selection } = useMultiSelect({ namespace, relation });

    const hasSelection = useMemo(() => {
        const keys = Object.keys(selection || {});
        // If __invertSelection is true, it means "Select All" was clicked, 
        // and we are in a state where everything is selected except for specific exclusions.
        if (selection?.__invertSelection) return true;
        return keys.some(key => key !== '__invertSelection' && selection[key] === true);
    }, [selection]);

    const isHidden = withSelection && !hasSelection;

    const activeRecord = useActiveRecord();
    const dbViewName = useGetDbViewName(namespace, relation, undefined);

    const actionPayload = useMemo(() => {
        return {
            record: activeRecord?.record,
            activeRecord,
            hNodeId: hNode.id,
            dbViewName,
            namespace,
            relation
        };
    }, [hNode.id, activeRecord, dbViewName, namespace, relation]);

    if (isHidden) {
        return null;
    }

    return rc(ActionMenuButton, {
        hNode,
        actionPayload,
        children,
        currentRoute,
        icons: hNode.icons,
        ...otherProps
    });
}

MenuButton.propTypes = {
    hNode: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        iconName: PropTypes.string,
        buttonStyle: PropTypes.string,
        style: PropTypes.string,
        namespace: PropTypes.string,
        relation: PropTypes.string,
        withSelection: PropTypes.bool,
        icons: PropTypes.bool
    }).isRequired,
    children: PropTypes.node,
    currentRoute: PropTypes.string
};
